import { i18n } from 'next-i18next';

import { toast } from '@thinkific/chalk/react-providers';

type ToastMessage = (content: string, description?: string) => void;
type ToastError = () => void;

export const genericToastAlert: ToastError = () => {
  toast({
    title:
      i18n?.t('Something went wrong. Please try again.') ||
      'Something went wrong. Please try again.',
    variant: 'danger',
  });
};

export const successToastMessage: ToastMessage = (content, description) => {
  toast({
    title: content,
    description,
    variant: 'success',
  });
};

export const failureToastMessage: ToastMessage = (content) => {
  toast({
    title: content,
    variant: 'danger',
  });
};

export const infoToastMessage: ToastMessage = (content) => {
  toast({
    title: content,
    variant: 'default',
  });
};
